import { statusColor } from "@/lib/billing";

export function StatusChip({ status, className = "" }) {
  const c = statusColor[status] || { bg: "#E2E8F0", fg: "#64748B", label: (status || "").toUpperCase() };
  return (
    <span
      data-testid={`status-chip-${status}`}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-bold tracking-wide ${className}`}
      style={{ backgroundColor: c.bg, color: c.fg }}
    >
      {c.label}
    </span>
  );
}
